<template>
  <div
    v-if="articles.length > 0"
    class="article-blocks"
  >
    <ArticleBlockComponent
      v-for="article in articles"
      :key="article.id"
      :article="article"
    />
  </div>
</template>

<script>
import ArticleBlockComponent from './ArticleBlockComponent.vue';

export default {
  components: {
    ArticleBlockComponent,
  },
  props: {
    articles: {
      default: () => [],
      type: Array,
    },
  },
};
</script>
